import { olympusService as e } from "../../services/olympus/olympus.service.js";
import { useStore as t } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react.mjs";
import { createStore as n } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/index.mjs";
import { useShallow as r } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react/shallow.mjs";
import { devtools as i } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/middleware.mjs";
import { assert as a } from "@magnopus-opensource/magnopus-web-common";
import { setContext as o } from "/home/runner/work/oko-web/oko-web/node_modules/@sentry/react/build/esm/index.js";
import { SpaceUserRole as s } from "@magnopus-opensource/connected-spaces-platform-web-api";
//#region src/lib/stores/current-space-store/useCurrentSpaceStore.ts
var c = n(i((t, n) => ({
	spaceEntered: !1,
	space: void 0,
	owner: "",
	shouldLeaveSpace: !1,
	awaitingSpawnSelection: !1,
	setAwaitingSpawnSelection: (e) => {
		t({ awaitingSpawnSelection: e });
	},
	setShouldLeaveSpace: (e) => {
		t({ shouldLeaveSpace: e });
	},
	setSpaceEntered: (e) => {
		t({ spaceEntered: e });
	},
	clear: () => {
		t({
			space: void 0,
			owner: void 0,
			shouldLeaveSpace: !1,
			spaceEntered: !1,
			awaitingSpawnSelection: !1
		}), o("currentSpace", null);
	},
	loadSpace: async (r, i) => {
		if (n().space?.id === r) return;
		let a = await e.client.spaces.getSpaceUsingGraphQL(r);
		return a !== n().space && (t({ space: a }), t({ owner: a?.owner.displayName })), o("currentSpace", {
			id: a.id,
			name: a.name,
			owner: a.owner.userId,
			created: a.createdAt
		}), a;
	},
	updateSpaceMetadata: (e) => {
		let r = n().space;
		r?.id && t({ space: {
			...r,
			metadata: e.metadata
		} });
	},
	updateSpaceRoles: (e, r) => {
		let i = n().space;
		if (!i || !i.id || !i.userIds) return;
		let o = { ...i }, c = !1, l = o.users?.find((t) => t.userId === e) ?? { userId: e };
		a(o.moderatorIds), a(o.moderators), a(o.userIds), a(o.users), r.includes(s.User) ? (o.userIds.includes(e) || (o.userIds = [...o.userIds, e], c = !0), o.users.find((t) => t.userId === e) || (o.users = [...o.users, l], c = !0)) : r.includes(s.User) || (o.userIds.includes(e) && (o.userIds = o.userIds.filter((t) => t !== e), c = !0), o.users.find((t) => t.userId === e) && (o.users = o.users.filter((t) => t.userId !== e), c = !0)), r.includes(s.Moderator) ? (o.moderatorIds.includes(e) || (o.moderatorIds = [...o.moderatorIds, e], c = !0), o.moderators.find((t) => t.userId === e) || (o.moderators = [...o.moderators, l], c = !0)) : r.includes(s.Moderator) || (o.moderatorIds.includes(e) && (o.moderatorIds = o.moderatorIds?.filter((t) => t !== e), c = !0), o.moderators.find((t) => t.userId === e) && (o.moderators = o.moderators.filter((t) => t.userId !== e), c = !0)), c && t({ space: o });
	}
}))), l = (e) => t(c, r(e));
//#endregion
export { c as currentSpaceStore, l as useCurrentSpaceStore };
